import React from "react";

const Stack = () => {
  return (
    <React.Fragment>
      <h3 className="title-font white-text ">
        Here are a few tools & technologies I’ve been working with:
      </h3>
      <ol className="stack-section ">
        <li>InDesign</li>
        <li>Photoshop</li>
        <li>Illustration</li>
        <li>Vector art</li>
        <li>Art</li>
        <li>Html5</li>
        <li>Css3</li>
        <li>Dream viewer</li>
      </ol>
    </React.Fragment>
  );
};
export default Stack;
